module.exports = __webpack_public_path__ + "static/media/Open-Sans-regular.c35ad7c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Open-Sans-regular/Open-Sans-regular.eot
// module id = 413
// module chunks = 0